import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { updateVehicleFilter } from '../actions';
import { selectVehicleFilter, selectFilterSingleValue, selectFilterValues } from '../selectors';
import { Dropdown } from '../../../components/Dropdown';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { Calendar } from '../../../components/Icon';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import { IconRightDecorator } from '../../../components/Icon/IconRightDecorator';
import { normalizeSearchString } from '../../../utils/normalizeSearchString';
import { parseCompany } from '../../Companies/helpers';
import { companySearch } from '../../Companies/actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_COMPANIES_SEARCH } from '../../Companies/constants';
import { Loader } from '../../../components/Loader';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { COLOR_GREY_TINT } from '../../../vars';
import { Button } from '../../../components/Buttons';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import cn from 'classnames';
import styles from './VehicleFilter.module.css';

import ButtonComponent from '../../../containers/App/Components/Button/Button';
import RangedDropdowns from '../../../containers/App/Components/RangedDropdowns/RangedDropdowns';
import NestedDropdownComponent from '../../../containers/App/Components/NestedDropdown/NestedDropdown';

const Container = styled.div`
  .ranged {
    min-width: ${props => (props.controlWidth ? props.controlWidth : '55%')};
  }

  min-width: ${props => (props.minWidth ? props.minWidth : '')};

  .button-filter-block {
    // position: absolute;
    top: -50px;
    left: 0px;
  }
  .selected {
    background-color: #0183d5 !important;
    color: white !important;
  }
`;
const DropdownContainer = styled.div`
  position: relative;
  width: 230px;
`;
const DropdownOptions = styled.ul`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: absolute;
  z-index: 10;
  box-sizing: border-box;
  border-radius: 0.375rem;
  top: 40px;
  left: 0;
  width: 100%;
  list-style: none;
  border: solid 1px #eee;
  padding: ${({ show }) => (show ? '0' : '0')};
  background-color: white;
  max-height: 200px;
  overflow: auto;
`;

const DropdownOption = styled.li`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#86b6fe3b' : 'white')};
  color: ${({ isSelected }) => (isSelected ? 'black' : 'inherited')};

  &:hover {
    background-color: #86b6fe3b;
    color: black;
  }
`;

const RightDecoratorFilter = styled.div`
  display: flex;
  background-color: red;
  justify-content: center;
  align-items: center;
  min-width: 100px;
  width: ${props => props.mobView && '100%'};
  height: 100%;
  padding: 6px;

  background-color: #cccccc;
  font-weight: 600;
  padding-left: 10px;
  font-size: 14px;
  color: #888888;
`;

const STATE = {
  selectedValues: [],
  selectedValue: null,
  selectedLabels: [],
  selectedLabel: '',
  altValue: null,
  showOptions: false,
  min: null,
  max: null,
  minDate: null,
  maxDate: null,
  text: '',
  company: null,
  user: null,
  searchLabel: '',
};

const MILEAGE_FROM = [
  0,
  5000,
  10000,
  20000,
  30000,
  40000,
  50000,
  60000,
  70000,
  80000,
  90000,
  100000,
  125000,
  150000,
  200000,
];
const MILEAGE_TO = [
  1000,
  3000,
  5000,
  10000,
  20000,
  30000,
  40000,
  50000,
  60000,
  70000,
  80000,
  90000,
  100000,
  125000,
  150000,
  200000,
];
const POWER_FROM = [25, 27, 44, 55, 66, 74, 87, 96, 110, 147, 185, 223, 263, 296, 334];
const POWER_TO = [25, 27, 44, 55, 66, 74, 87, 96, 110, 147, 185, 223, 263, 296, 334];
const PRICE_FROM = [
  0,
  2500,
  5000,
  7500,
  10000,
  15000,
  20000,
  25000,
  30000,
  40000,
  50000,
  60000,
  70000,
  80000,
  90000,
  100000,
];
const PRICE_TO = [
  2500,
  5000,
  7500,
  10000,
  15000,
  20000,
  25000,
  30000,
  40000,
  50000,
  60000,
  70000,
  80000,
  90000,
  100000,
  150000,
  200000,
];

/* eslint-disable react/prefer-stateless-function */
class VehicleFilterComp extends BaseComponent {
  constructor(props) {
    let filterPair = props.filter?.properties?.find(f => f.key === props.name);
    let filterValue = filterPair?.value;
    let filterLabel = filterPair?.label;
    let updateState = {};

    if (filterValue) {
      switch (props.type) {
        case 'single':
          updateState = { selectedValue: filterValue[0] ?? null, selectedLabel: filterLabel[0] ?? '' };
          break;
        case 'multiple':
          updateState = { selectedValues: filterValue ?? [], selectedLabels: filterLabel ?? [] };
          break;
        case 'ranged':
          updateState = { min: filterValue[0] ?? '', max: filterValue[1] ?? '' };
          break;
        case 'ranged_date':
          updateState = {
            minDate: filterValue[0] ?? null,
            maxDate: filterValue[1] ?? null,
            selectedLabels: filterLabel ?? [],
          };
          break;
      }
    }

    super(props, {
      ...STATE,
      ...updateState,
      search: props.filter?.searchString || '',
    });

    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.altKey && prevState.selectedValue !== this.state.selectedValue) {
      if (this.state.selectedValue === null || this.state.selectedValue === '') {
        this.props.reset();
      } else {
        this.props.change(this.state.selectedValue, this.props.name, this.state.selectedLabel);
      }
    }
    if (this.props.altKey && prevState.altValue !== this.state.altValue) {
      if (this.state.altValue === null || this.state.altValue === '') {
        this.props.reset(true);
      } else {
        this.props.change(this.state.altValue, this.props.altKey);
      }
    }
    if (prevState.selectedValue !== this.state.selectedValue && !this.props.altKey) {
      if (this.state.selectedValue === null || this.state.selectedValue === '') {
        this.props.reset();
      } else {
        this.props.changeValues([this.state.selectedValue + ''], [this.state.selectedLabel]);
      }
    }
    if (!_.isEqual(prevState.selectedValues, this.state.selectedValues)) {
      if (!this.state.selectedValues.length) {
        this.props.reset();
      } else {
        this.props.changeValues(this.state.selectedValues, this.state.selectedLabels);
      }
    }
    if (prevState.min !== this.state.min || prevState.max !== this.state.max) {
      this.props.changeValues([this.state.min ?? '0', this.state.max ?? '0']);
    }
    if (prevState.minDate !== this.state.minDate || prevState.maxDate !== this.state.maxDate) {
      this.props.changeValues(
        [
          this.state.minDate ?? this.rangedOptionsFrom[0]?.value,
          this.state.maxDate ?? this.rangedOptionsTo[this.rangedOptionsTo?.length - 1]?.value,
        ],
        this.state.selectedLabels,
      );
    }
    if (prevState[this.props.search] !== this.state[this.props.search]) {
      this.props.changeValues([this.state[this.props.search] + ''], [this.state.searchLabel]);
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  compareLabel = (a, b) => {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  };

  get options() {
    if (this.props.noModify && this.props.options?.length) {
      return this.props.options?.map(o => ({ label: o?.label, value: o?.value + '' }))?.sort(this.compareLabel);
    }
    const res = !!this.props.isBool ? [] : [{ label: `${this.lblStr('vehicle.filter.empty')}`, value: '-' }];
    const optionsToParse = this.props.isBool
      ? ['no', 'yes']
      : this.props.search
      ? []
      : this.props.options?.sort((a, b) => {
          if (a < b) {
            return -1;
          } else if (a > b) {
            return 1;
          } else return 0;
        });
    return res.concat(
      optionsToParse
        ?.map(value => {
          const lbl = this.lblStr(`vehicle.filter.${value}`) ?? '';
          return {
            label: `${lbl}` ?? value,
            value: this.props.isBool ? (value === 'yes' ? '1' : value === 'no' ? '0' : null) : value,
          };
        })
        ?.sort(() => this.compareLabel),
    );
  }

  get multiOptions() {
    if (this.props.noModify) return this.props.options?.sort(this.compareLabel);
    if (this.props.name === 'status') {
      const parsedOptions = this.props.options
        ?.map((option, code) => {
          const statusValue = env.clientId === AppClientId.HILTERMANN ? 6 + code : code;
          return { label: option, value: statusValue + '' };
        })
        ?.sort(this.compareLabel);
      return parsedOptions;
    }
    if (this.state.text) {
      return this.props.options
        ?.filter(option => option?.toLowerCase()?.includes(this.state.text.toLowerCase()))
        ?.map(option => ({ label: option, value: option.toLowerCase() }))
        ?.sort(this.compareLabel);
    }
    return [{ label: `${this.lblStr('vehicle.filter.empty')}`, value: '-' }].concat(
      this.props.options
        ?.map(option => {
          return { label: this.lblStr(`${option}`), value: option.toLowerCase() };
        })
        ?.sort(this.compareLabel),
    );
  }

  get rangedOptionsFrom() {
    switch (this.props.name) {
      case 'mileage':
        return MILEAGE_FROM?.map(item => ({ label: item + '', value: item + '' }));
      case 'power':
        return POWER_FROM?.map(item => ({ label: item + '', value: item + '' }));
      default:
        return PRICE_FROM?.map(item => ({ label: item + '', value: item + '' }));
    }
  }

  get rangedOptionsTo() {
    switch (this.props.name) {
      case 'mileage':
        return MILEAGE_TO?.map(item => ({ label: item + '', value: item + '' }));
      case 'power':
        return POWER_TO?.map(item => ({ label: item + '', value: item + '' }));
      default:
        return PRICE_TO?.map(item => ({ label: item + '', value: item + '' }));
    }
  }

  get value() {
    return this.options.find(o => o.value === this.props.filterSingleValue);
  }

  toggleViewOptions = () => {
    this.setState(state => ({ showOptions: !state.showOptions }));
  };

  toggleAltFilters = value => {
    if (value == 1) {
      this.setState({ selectedValue: '1', altValue: '0', selectedLabel: 'yes' });
    } else if (value == 0) {
      this.setState({ selectedValue: '0', altValue: '1', selectedLabel: 'no' });
    } else if (value == null) {
      this.setState({ selectedValue: '0', altValue: '0', selectedLabel: '' });
    }
  };

  renderSingleFilter = () => {
    const handleChange = pair => {
      console.log(pair);
      return pair.value === null
        ? this.props.setState({ selectedValue: null, selectedLabel: '' })
        : this.props.altKey && this.props.isBool
        ? this.toggleAltFilters(pair.value)
        : this.setState({ selectedValue: pair.value, selectedLabel: pair.label });
    };
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.label[0];

    return (
      <SearchSelect
        placeholder={this.props.label ?? this.lblStr(`vehicle.filter.${this.props.name}`)}
        options={this.options}
        value={selected && { label: selected }}
        onChange={handleChange}
        className="filter"
      />
    );
  };

  toggleOption = (value, label, option) => {
    this.setState(state => {
      if (option == 'buttonFilter') {
        return {
          selectedValues: state.selectedValues.includes(value)
            ? state.selectedValues.filter(v => v !== value)
            : [...state.selectedValues, value],
          selectedLabels: state.selectedLabels.includes(label)
            ? state.selectedLabels.filter(l => l !== label)
            : [...state.selectedLabels, label],
        };
      }

      return {
        selectedValues: [...value],
        selectedLabels: [...label],
      };
    });
  };

  handleMultiselectSearch = e => {
    this.setState({ text: e.target.value, showOptions: !!e.target.value?.length });
  };

  renderMultipleFilter = () => {
    let isActiveButton = false;
    const label = this.props.label ?? this.lblStr(`vehicle.filter.${this.props.name}`);
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name);
    let selectedResult = [];

    selected?.value?.map((val, index) => {
      selectedResult?.push({
        value: val,
        label: selected?.label[index],
      });
    });

    if (this.props.buttonFilter) {
      return (
        <div className={cn(styles.buttonFilterContainer, 'd-flex gap-2')}>
          {env.clientId != AppClientId.HILTERMANN && (
            <>
              {env.clientId === AppClientId.INDEWAL ? (
                <ButtonComponent
                  select={selected?.value?.includes('1') || selected?.value?.includes('0')}
                  onClick={() => {
                    this.toggleOption('1', 'Consignment', 'buttonFilter');
                    this.toggleOption('0', 'Te verkopen', 'buttonFilter');
                  }}
                  style={
                    selected?.value?.includes('1') || selected?.value?.includes('0')
                      ? 'ButtonSoftShortSort'
                      : 'ButtonSelectedStyle'
                  }
                >
                  {this.lbl('vehicle.overview.stock')}
                </ButtonComponent>
              ) : (
                <ButtonComponent
                  select={selected?.value?.includes('1') || selected?.value?.includes('0')}
                  onClick={() => {
                    //this.toggleOption('1', 'Consignment', 'buttonFilter');
                    this.toggleOption('0', 'Te verkopen', 'buttonFilter');
                  }}
                  style={
                    selected?.value?.includes('1') || selected?.value?.includes('0')
                      ? 'ButtonSoftShortSort'
                      : 'ButtonSelectedStyle'
                  }
                >
                  {this.lbl('vehicle.overview.stock')}
                </ButtonComponent>
              )}
              <ButtonComponent
                select={selected?.value?.includes('2')}
                small
                onClick={() => {
                  this.toggleOption('2', 'Gereserveerd', 'buttonFilter');
                }}
                style={selected?.value?.includes('2') ? 'ButtonSoftShortSort' : 'ButtonSelectedStyle'}
              >
                {this.lbl('vehicle.property.status.2')}
              </ButtonComponent>

              {env.clientId === AppClientId.AUTOHUISSALLAND && (
                <ButtonComponent
                  select={selected?.value?.includes('1')}
                  small
                  onClick={() => {
                    this.toggleOption('1', 'Geen eigendom', 'buttonFilter');
                  }}
                  style={selected?.value?.includes('1') ? 'ButtonSoftShortSort' : 'ButtonSelectedStyle'}
                >
                  {this.lbl('vehicle.property.status.geen_eigendom')}
                </ButtonComponent>
              )}

              <ButtonComponent
                select={selected?.value?.includes('4')}
                small
                onClick={() => {
                  this.toggleOption('4', 'Geblokkeerd', 'buttonFilter');
                }}
                style={selected?.value?.includes('4') ? 'ButtonSoftShortSort' : 'ButtonSelectedStyle'}
              >
                {this.lbl('vehicle.property.status.4')}
              </ButtonComponent>

              <ButtonComponent
                onClick={() => {
                  this.toggleOption('3', 'Sold', 'buttonFilter');
                }}
                style={selected?.value?.includes('3') ? 'ButtonSoftShortSort' : 'ButtonSelectedStyle'}
              >
                {this.lbl('vehicle.property.status.3')}
              </ButtonComponent>
            </>
          )}
          {env.clientId === AppClientId.HILTERMANN && (
            <>
              <ButtonComponent
                onClick={() => {
                  this.toggleOption('7', 'Expected', 'buttonFilter');
                }}
                style={selected?.value?.includes('7') ? 'ButtonSoftShortSort' : 'ButtonSelectedStyle'}
              >
                {this.lbl('vehicle.property.status.extra.7')}
              </ButtonComponent>
              <ButtonComponent
                onClick={() => {
                  this.toggleOption('8', 'Stocked', 'buttonFilter');
                }}
                style={selected?.value?.includes('8') ? 'ButtonSoftShortSort' : 'ButtonSelectedStyle'}
              >
                {this.lbl('vehicle.property.status.extra.8')}
              </ButtonComponent>
              <ButtonComponent
                onClick={() => {
                  this.toggleOption('9', 'Distributed', 'buttonFilter');
                }}
                style={selected?.value?.includes('9') ? 'ButtonSoftShortSort' : 'ButtonSelectedStyle'}
              >
                {this.lbl('vehicle.property.status.extra.9')}
              </ButtonComponent>
            </>
          )}
        </div>
      );
    }

    if (this.props.nestedFilter) {
      return (
        <NestedDropdownComponent
          isMulti
          closeMenuOnSelect={false}
          selectedResult={selectedResult}
          onChange={e => {
            const values = e.map(item => item.value);
            const labels = e.map(item => item.label);
            this.toggleOption(values, labels);
          }}
          placeholder={label}
          options={this.multiOptions}
        />
      );
    }

    return (
      <SearchSelect
        isMulti
        closeMenuOnSelect={false}
        value={selectedResult}
        onChange={e => {
          const values = e.map(item => item.value);
          const labels = e.map(item => item.label);
          this.toggleOption(values, labels);
        }}
        placeholder={label}
        options={this.multiOptions}
      />
    );
  };

  renderRangedFilter = () => {
    const label = this.props.label ?? this.lblStr(`vehicle.filter.right_decor.${this.props.name}`);
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.value;
    let selMin = selected?.length ? selected[0] : null;
    let selMax = selected?.length ? selected[1] : null;
    return (
      <RangedDropdowns label={label}>
        <div className={styles.dropdownContainer}>
          <Dropdown
            name="min"
            placeholder={this.lblStr('vehicle.filter.from')}
            options={this.rangedOptionsFrom}
            value={selMin}
            onChange={item =>
              this.setState({
                min: item?.value,
                max: selMax ?? this.rangedOptionsTo[this.rangedOptionsTo?.length - 1]?.value,
              })
            }
            className={cn('ranged wider', styles.renderDropdown)}
          />
        </div>
        <div className={styles.dropdownContainer}>
          <Dropdown
            name="max"
            placeholder={this.lblStr('vehicle.filter.to')}
            options={this.rangedOptionsTo}
            value={selMax}
            onChange={item => this.setState({ max: item?.value, min: selMin ?? this.rangedOptionsFrom[0]?.value })}
            className={cn('ranged wider', styles.renderDropdown)}
          />
        </div>
      </RangedDropdowns>
    );
  };

  renderDateFilter = () => {
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.value;
    let selMin = selected?.length ? selected[0] : null;
    let selMax = selected?.length ? selected[1] : null;
    let formatMin = selMin?.charAt(2) === '-' ? 'DD-MM-YYYY' : undefined;
    let selectedMin = selMin && dayjs(selMin, formatMin);
    let formatMax = selMax?.charAt(2) === '-' ? 'DD-MM-YYYY' : undefined;
    let selectedMax = selMax && dayjs(selMax, formatMax);
    const updateLabels = this.state.selectedLabels;
    return (
      <FormField
      // label={this.props.label ?? this.lblStr(`vehicle.filter.${this.props.name}`)}
      >
        <IconRightDecorator icon={<Calendar />} />

        <DatePicker
          className="small"
          dateFormat="dd-MM-yyyy"
          selected={selectedMin && selectedMin?.toDate()}
          onChange={date => {
            let d = dayjs(date).format('DD-MM-YYYY');
            this.setState({ minDate: d, selectedLabels: updateLabels.splice(0, 1, d) });
          }}
        />
        <IconRightDecorator icon={<Calendar />} />
        <DatePicker
          className="small"
          dateFormat="dd-MM-yyyy"
          selected={selectedMax && selectedMax?.toDate()}
          onChange={date => {
            let d = dayjs(date).format('DD-MM-YYYY');
            this.setState({ maxDate: d, selectedLabels: updateLabels.splice(1, 1, d) });
          }}
        />
      </FormField>
    );
  };

  searchCompany = () => {
    const searchText = normalizeSearchString(this.state.text);
    if (!searchText) return;
    this.props.searchCompany(this.state.text, result =>
      this.setState({
        showOptions: true,
        options: result?.items
          ?.map(parseCompany)
          ?.filter(company => {
            let filtered =
              (company.id !== this.state.company?.id && company?.__search?.indexOf(searchText) > -1) ||
              company.__email_search.indexOf(searchText) > -1;

            if (this.props.changeLocation) {
              filtered = company.__search.indexOf(searchText) > -1 || company.__email_search.indexOf(searchText) > -1;
            }

            return filtered;
          })
          ?.map(c => ({
            label: c.company_type === 'company' ? c?.name : `${c?.name}${c?.surname ? ' ' + c?.surname : ''}`,
            value: c?.id + '',
          })),
      }),
    );
  };

  search = () => {
    this._t = this.timeout(this.searchCompany, 600, this._t);
  };

  selectSearchOption = option => {
    this.setState({ [this.props.search]: option?.value, searchLabel: option?.label, text: '', showOptions: false });
  };

  onStringChange = evt => {
    let text = evt.target.value;
    this.setState({ text });
    let debounced = _.debounce(this.search, 300, { maxWait: 1000 });
    debounced();
  };

  renderSingleSearchFilter = () => {
    const label = this.props.label ?? this.lblStr(`vehicle.filter.${this.props.name}`);
    if (this.props.search === 'company') {
      return (
        <div ref={this.wrapperRef} style={{ position: 'relative', width: '100%' }}>
          <div style={{ backgroundColor: 'white', display: 'flex', gap: '5px', height: '36px', width: '100%' }}>
            <input
              type="text"
              className="form-control fw-lighter"
              name="text"
              onChange={this.onStringChange}
              value={this.state.text}
              placeholder={label}
            />
            {this.props.searching ? (
              <ButtonComponent style={'ButtonSoftPrimaryShort'}>
                <Loader small />
              </ButtonComponent>
            ) : null}
          </div>
          {!!this.state.showOptions && (
            <DropdownOptions show={!!this.state.showOptions}>
              {this.state.options?.map((option, idx) => {
                return (
                  <DropdownOption
                    isSelected={option.value === this.state[this.props.search]}
                    key={`${this.props.name}_${option?.value}`}
                    onClick={() => this.selectSearchOption(option)}
                  >
                    <span>{option?.label}</span>
                  </DropdownOption>
                );
              })}
            </DropdownOptions>
          )}
        </div>
      );
    }
  };

  renderYearFilter = () => {
    const label = this.props.label ?? this.lblStr(`vehicle.filter.right_decor.${this.props.name}`);
    const lastYear = new Date().getFullYear();
    let years = [];
    for (let i = lastYear; i >= 2005; i--) {
      years.push(i);
    }
    const minOptions = years.map(year => ({ label: year + '', value: `01-01-${year}` }));
    minOptions.push({ label: '< 2005', value: '01-01-1970' });
    const maxOptions = years.map(year => ({ label: year + '', value: `31-12-${year}` }));
    maxOptions.push({ label: '< 2005', value: '31-12-2004' });
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.value ?? [];
    let selLbl = this.props.filter.properties?.find(p => p.key === this.props.name)?.label ?? [];
    let min = selected?.length ? selected[0] : '';
    let max = selected?.length ? selected[1] : '';

    let minLabel = min === '0' ? 'from' : min;
    let maxLabel = max === '200000' ? 'to' : max;

    const setMinDate = item => this.setState({ minDate: item?.value, selectedLabels: [item?.label, selLbl[1] ?? ''] });
    const setMaxDate = item => this.setState({ maxDate: item?.value, selectedLabels: [selLbl[0] ?? '', item?.label] });
    return (
      <RangedDropdowns label={label}>
        <div className={styles.dropdownContainer}>
          <Dropdown
            name="min"
            placeholder={this.lblStr('vehicle.filter.from')}
            options={minOptions}
            value={minLabel && { label: min !== '0' ? dayjs(minLabel).format('YYYY') : 'from' }}
            onChange={setMinDate}
            className={styles.renderDropdown}
          />
        </div>

        <div className={styles.dropdownContainer}>
          <Dropdown
            name="max"
            placeholder={this.lblStr('vehicle.filter.to')}
            options={maxOptions}
            value={maxLabel && { label: max !== '200000' ? dayjs(maxLabel, 'YYYY').format('YYYY') : 'to' }}
            onChange={setMaxDate}
            className={styles.renderDropdown}
          />
        </div>
      </RangedDropdowns>
    );
  };

  handleClickOutside = e => {
    if (!!this.wrapperRef && !this.wrapperRef?.current?.contains(e.target) && !!this.state.showOptions) {
      this.setState({ showOptions: false });
    }
  };

  render() {
    return (
      <div>
        {this.props.type === 'single' && !this.props.search && this.renderSingleFilter()}
        {this.props.type === 'multiple' && this.renderMultipleFilter()}
        {this.props.type === 'ranged' && this.renderRangedFilter()}
        {this.props.name === 'date_first_allowance' && this.renderYearFilter()}
        {this.props.type === 'ranged_date' && this.props.name !== 'date_first_allowance' && this.renderDateFilter()}
        {this.props.type === 'single' && this.props.search && this.renderSingleSearchFilter()}
      </div>
    );
  }
}

VehicleFilterComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  label: PropTypes.string,
  isBool: PropTypes.bool,
  altKey: PropTypes.string,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectVehicleFilter(),
    filterSingleValue: selectFilterSingleValue(ownProps.name),
    values: selectFilterValues(ownProps.name),
    searching: selectWork(REQUEST_COMPANIES_SEARCH),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset(alt = false) {
      dispatch(
        updateVehicleFilter(null, {
          reset: alt ? ownProps.altKey : ownProps.name,
        }),
      );
    },
    changeValues(values, labels = []) {
      dispatch(
        updateVehicleFilter({
          key: ownProps.name,
          value: values,
          label: labels,
          type: ownProps.type,
        }),
      );
    },
    change(value, key, label = '') {
      dispatch(
        updateVehicleFilter({
          key: key,
          value: [value.toString().toLowerCase()],
          label: [label],
          type: ownProps.type,
        }),
      );
    },
    searchCompany(text, callback) {
      dispatch(companySearch(text, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleFilter = compose(withConnect, withRouter, injectIntl)(VehicleFilterComp);
